export default {
	cookieName: 'GeoLocation'
};
